import { T } from 'gt-react';
import {
  CaretDownIcon,
  DownloadSimpleIcon,
  FileCsvIcon,
  FileXlsIcon,
} from '@phosphor-icons/react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

export function RebateReportDownloadMenu({
  onDownload,
  disabled = false,
}: {
  onDownload: (format: 'csv' | 'xlsx') => void;
  disabled?: boolean;
}) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" disabled={disabled}>
          <DownloadSimpleIcon className="h-4 w-4" />
          <T context="rebates report download dropdown button">Download</T>
          <CaretDownIcon className="h-3 w-3 opacity-60" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem
          onClick={() => onDownload('csv')}
          className="cursor-pointer gap-2"
        >
          <FileCsvIcon className="h-4 w-4" />
          <T context="rebates report download CSV option">CSV</T>
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => onDownload('xlsx')}
          className="cursor-pointer gap-2"
        >
          <FileXlsIcon className="h-4 w-4" />
          <T context="rebates report download Excel option">Excel (.xlsx)</T>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
